import { inject, observer } from "mobx-react";
import LocationSelector, {
    LocationItem,
} from "../../../../components/location-selector/LocationSelector";
import { TreeNodeItem } from "../../../../components/tree-select/TreeSelect";
import styles from "./header.module.css";
import LocationSelectorStore from "../../../../store/location-selector-store";
import { ManageLocationStore } from "../../store/store";
import { getCamerasById, getSensorEventsById } from "../../web";
import moment from "moment";

interface HeaderProps {
    locationSelectorStore?: LocationSelectorStore;
    manageLocationsStore?: ManageLocationStore;
}

function Header(props: HeaderProps) {
    const locationSelectorStore = props.locationSelectorStore!;
    const manageLocationsStore = props.manageLocationsStore!;
    const locationId = manageLocationsStore.selectedLocationId;

    const getLocationList = () => {
        const locationItemList: LocationItem[] =
            locationSelectorStore.selectedRoomList.map((room: TreeNodeItem) => {
                return {
                    locationId: room.id,
                    locationName: room.name,
                    areaName: room.path || "",
                    hasTelecareCapability: room.hasTelecareCapability,
                };
            });

        if (
            !locationItemList
                .map((item) => {
                    return item.locationId;
                })
                .includes(locationId)
        ) {
            manageLocationsStore.setSensorEventList([]);
            manageLocationsStore.setCameraList([]);
        }

        return locationItemList;
    };

    const render = () => {
        return (
            <div className={styles["header"]}>
                <div className={styles["location-selector"]}>
                    <LocationSelector
                        selectedId={manageLocationsStore.getSelectedLocationId()}
                        locationList={getLocationList()}
                        onValueChange={(value: LocationItem) => {
                            manageLocationsStore.loadingCameras = true;
                            manageLocationsStore.loadingSensor = true;

                            getCamerasById(value.locationId!)
                                .then((response) => {
                                    const list =
                                        response.data.locationCamerasDetails;
                                    manageLocationsStore.setCameraList(list);
                                    manageLocationsStore.loadingCameras = false;
                                })
                                .catch(() => {
                                    manageLocationsStore.setCameraList([]);
                                    manageLocationsStore.loadingCameras = false;
                                });

                            getSensorEventsById(value.locationId!)
                                .then((response) => {
                                    const list = response.data.sensorEvents.map(
                                        (sensorEvent: any) => {
                                            return {
                                                eventType:
                                                    sensorEvent.sensorEvent,
                                                sensorType:
                                                    sensorEvent.sensorId,
                                                timestamp: moment(
                                                    sensorEvent.timestamp
                                                ).format("D MMM YYYY HH:mm:ss"),
                                            };
                                        }
                                    );
                                    manageLocationsStore.setSensorEventList(
                                        list
                                    );
                                    manageLocationsStore.loadingSensor = false;
                                })
                                .catch(() => {
                                    manageLocationsStore.setSensorEventList([]);
                                    manageLocationsStore.loadingSensor = false;
                                });

                            manageLocationsStore.setSelectedLocationId(
                                value.locationId!
                            );
                        }}
                    />
                </div>
            </div>
        );
    };

    return render();
}

export default inject(
    "locationSelectorStore",
    "manageLocationsStore"
)(observer(Header));
